module.exports = __webpack_public_path__ + "img/bostie_and_leash.631310b8.svg";